module.exports = __webpack_public_path__ + "img/Union.54472151.svg";